import { makeStyles } from 'tss-react/mui';
export default makeStyles()(function (theme) {
  return {
    root: {
      position: 'relative',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      maxHeight: '20px'
    },
    loading: {
      zIndex: 10
    },
    backdrop: {
      zIndex: 9,
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'rgba(0, 0, 0, 0.4)'
    },
    linearPrimary: {
      background: 'linear-gradient(138deg, #087ee1, #05e8ba 95%)'
    },
    linearSecondary: {
      backgroundColor: theme.palette.primary.light,
      '& .MuiLinearProgress-barColorPrimary': {
        backgroundColor: '#70efde'
      }
    },
    circularPrimary: {
      color: theme.palette.primary.main
    },
    circularSecondary: {
      color: theme.palette.secondary.main
    },
    circularTertiary: {
      // color: theme.palette.tertiary?.main
    }
  };
});